import intersection from 'lodash/intersection'
import property from 'lodash/property'

export type AccessLevel = 'premium' | 'default' | 'limited_audio' | 'audio'

export const hasAppropriateActiveSubscription = (
  book,
  accessLevels: AccessLevel[],
): boolean => {
  const accessRestrictions = book.access_restrictions.map(property('level'))

  if (!accessRestrictions.length) return true
  else return intersection(accessRestrictions, accessLevels).length > 0
}
